import 'css-chunk:src/applications/ReportsApp/pages/Reporting/components/Header/Header.module.scss';export default {
  "Header": "_Header_h0ny1_1",
  "icon": "_icon_h0ny1_7"
};